import React, { useState } from "react";
import { FaTimes, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import brandIcon from "assets/images/logo.png";
import OAuthButton from "../ConnectedPlatformAuthoriseButton";

const ConnectedPlatformModal = ({
  adsConfiguration,
  isOpen,
  onClose,
  handleOpenApiConfigurationModal,
  isOAuth = false,
}) => {
  const [shopName, setShopName] = useState(""); // State for Shopify store name
  const isShopifyOAuth = adsConfiguration?.slug === "shopify-oauth";

  if (!isOpen) return null;

  // Construct authUrl with shop name for Shopify OAuth Ads, only if shopName is provided
  const authUrl =
    isShopifyOAuth && shopName
      ? `${adsConfiguration.authUrl}?shop=${shopName}`
      : adsConfiguration?.authUrl;

  return (
    <div>
      <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative">
          {/* Close Icon */}
          <button
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
            onClick={onClose}
          >
            <FaTimes size={20} />
          </button>

          {/* Icons on top-left */}
          <div className="flex items-center gap-2 mb-4">
            <img
              src={brandIcon}
              alt={"Onebots"}
              className="flex-grow-0"
              style={{ height: "20px" }}
            />
          </div>
          {adsConfiguration ? (
            <>
              {/* Heading and Subheading */}
              <h2 className="text-lg font-bold text-gray-800 mb-2">
                Onebotads would like access to {adsConfiguration.name}
              </h2>
              <p className="text-sm text-gray-600 mb-4">
                This will allow Onebotads to:
              </p>
              {/* Bullet Points */}
              <div className="border border-gray-200 rounded-lg p-4 mb-4">
                <ul>
                  {adsConfiguration.permissions.map((permission, index) => (
                    <li
                      key={index}
                      className="flex items-center gap-2 text-sm text-gray-700"
                    >
                      {permission.isAllowed ? (
                        <FaCheckCircle className="text-green-500" />
                      ) : (
                        <FaTimesCircle className="text-red-500" />
                      )}
                      {permission.detail}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Shopify OAuth Ads Input Field */}
              {isShopifyOAuth && (
                <div className="space-y-4 mb-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Shopify Store Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={shopName}
                      onChange={(e) => setShopName(e.target.value)}
                      placeholder="e.g., mystore.myshopify.com"
                      className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      required
                    />
                  </div>
                  <div className="text-xs text-gray-500 italic">
                    Enter your Shopify store name (e.g., mystore.myshopify.com)
                    to connect your OAuth Ads account. This field is required.
                  </div>
                </div>
              )}

              {/* Buttons */}
              <div className="flex justify-end gap-4">
                <button
                  onClick={onClose}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                {isOAuth ? (
                  <OAuthButton
                    platform={adsConfiguration.slug}
                    adsConfiguration={{ ...adsConfiguration, authUrl }} // Pass updated authUrl with shop name
                    disabled={isShopifyOAuth && !shopName} // Disable if no shop name for Shopify OAuth
                  />
                ) : (
                  <button
                    className="px-4 py-2 bg-[#221C51] text-white rounded-lg hover:bg-[#1a1641]"
                    onClick={handleOpenApiConfigurationModal}
                  >
                    Authorise
                  </button>
                )}
              </div>
            </>
          ) : (
            <p>Ads Configuration not found!</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectedPlatformModal;
